import * as Configuration from './../../app.constants.js';

export class SegmentsService {
  constructor($http, $q, $translate, StrategiesFactory, DropdownItemsFactory) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
    this.StrategiesFactory = StrategiesFactory;
    this.DropdownItemsFactory = DropdownItemsFactory;

    this._boxWithButtonsHelpers = {
      question: {
        boxLabelFn: box => (shorten(box.content) || $translate.instant('parameters/quick_replies/details/graph/question_box_title_in_panel')),
        buttonSubItemsFn: (box, allElementsById) => buttonSubItems(box, 'answers', 'answer', allElementsById)
      },
      messengerMediaTemplateAManoBox: {
        boxLabelFn: box => $translate.instant('parameters/quick_replies/details/graph/messenger_media_template_box_title_in_panel'),
        buttonSubItemsFn: (box, allElementsById) => buttonSubItems(box, 'buttonsAndHeaders', 'messengerButton', allElementsById)
      },
      messengerButtonTemplateAManoBox: {
        boxLabelFn: box => (shorten(box.element.text) || $translate.instant('parameters/quick_replies/details/graph/messenger_button_template_box_title_in_panel')),
        buttonSubItemsFn: (box, allElementsById) => buttonSubItems(box, 'buttonsAndHeaders', 'messengerButton', allElementsById)
      },
      messengerGenericTemplateAManoBox: {
        boxLabelFn: box => ((box.elements.length > 0 && box.elements[0].title)
          ? shorten(box.elements[0].title)
          : $translate.instant('parameters/quick_replies/details/graph/messenger_button_template_box_title_in_panel')),
        buttonSubItemsFn: (box, allElementsById) => buttonSubItems(box, 'buttonsAndHeaders', 'messengerButton', allElementsById)
      },
    }
  }

  getSegments(companyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/segments');
  }

  updateSegments(companyId, config) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/segments', config);
  }

  buildDropdownItems(languages, scenarios, surveyScenarios, optins, allCustomFields) {

    languages.forEach(l => l.label = l.name);
    const customFieldsMap = new Map();
    const customFields = (allCustomFields || [])
      .filter(({ type, scope }) => scope === 'user' && ['integer', 'float', 'boolean', 'string', 'email', 'url', 'date', 'datetime', 'enum', 'multipicklist'].includes(type.type))
      .map(customField => {
        customFieldsMap.set(customField.id, customField);
        return {
          id: customField.id,
          label: `${customField.label} (${customField.type.type})`,
        };
      });
    return {
      languages,
      scenarios: this._buildScenariosWithButtonsItems(scenarios),
      surveyScenarios: this._buildSurveyScenarioItems(surveyScenarios),
      optins: optins.length > 0 ? this.DropdownItemsFactory.buildOptinItems(optins) : [],
      customFields,
      customFieldsMap,
    }
  }

  _buildScenariosWithButtonsItems(scenarios) {
    return scenarios.map(scenario => this._buildScenarioWithButtonsItem(scenario));
  }


  _buildScenarioWithButtonsItem(scenario) {
    const allElementsById = scenario.graphs.all_time ? scenario.graphs.all_time.elements : {}; // ignore bh/nbh scenarios (there should be none left)
    const allElements = Object.values(allElementsById);
    const boxesWithBtns = allElements.filter(element => Object.keys(this._boxWithButtonsHelpers).includes(element.type));
    boxesWithBtns.forEach(box => {
      const helpers = this._boxWithButtonsHelpers[box.type];
      box.label = helpers.boxLabelFn(box);
      box.btns = helpers.buttonSubItemsFn(box, allElementsById);
    });
    return {
      'id': scenario.id,
      'label': scenario.name,
      'boxesWithBtns': boxesWithBtns,
    };
  }


  _buildSurveyScenarioItems(scenarios) {
    return scenarios.map(scenario => this._buildSurveyScenarioItem(scenario));
  }


  _buildSurveyScenarioItem(scenario) {
    const allElementsById = scenario.graphs.all_time ? scenario.graphs.all_time.elements : {}; // ignore bh/nbh scenarios (there should be none left)
    const surveyBoxes = Object.values(allElementsById)
      .filter(box => box.type === 'surveyFeedbackBox');
    surveyBoxes.forEach(box => {
      const hasMessageText = box.elementData.message && box.elementData.message.text;
      box.label = hasMessageText ? box.elementData.message.text.substring(0, 25) : box.elementData.feedbackType;
    });
    return {
      'id': scenario.id,
      'label': scenario.name,
      'surveyBoxes': surveyBoxes
    };
  }

  static SegmentsFactory($http, $q, $translate, StrategiesFactory, DropdownItemsFactory) {
    return new SegmentsService($http, $q, $translate, StrategiesFactory, DropdownItemsFactory);
  }
}

SegmentsService.SegmentsFactory.$inject = ['$http', '$q', '$translate', 'StrategiesFactory', 'DropdownItemsFactory'];




function shorten(text) {
  return (text && text.length > 25) ? text.substring(0, 25) + '\u2026' : text;
}

function buttonSubItems(box, childrenPropertyName, buttonElementType, allElementsById) {
  const buttons = box[childrenPropertyName].map(id => allElementsById[id])
    .filter(element => element.type === buttonElementType);
  buttons.forEach(button => button.label = buttonLabel(button, buttonElementType));
  return buttons;
}

function buttonLabel(button, buttonElementType) {
  switch (buttonElementType) {
    case 'messengerButton':
      return shorten(button.button.title);
    case 'answer':
      return shorten(button.label);
    default:
      return '?';
  }
}